import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M5.25 6.382a4.125 4.125 0 1 1 8.25 0 4.125 4.125 0 0 1-8.25 0m4.125-2.625a2.625 2.625 0 1 0 0 5.25 2.625 2.625 0 0 0 0-5.25",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M18 6.757a.75.75 0 0 1 .75.75v2.25H21a.75.75 0 1 1 0 1.5h-2.25v2.25a.75.75 0 0 1-1.5 0v-2.25H15a.75.75 0 0 1 0-1.5h2.25v-2.25a.75.75 0 0 1 .75-.75"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M2.25 19.132a7.125 7.125 0 0 1 14.25 0v.002l-.001.12a.75.75 0 0 1-.363.63 13.07 13.07 0 0 1-6.761 1.873c-2.472 0-4.786-.684-6.76-1.873a.75.75 0 0 1-.364-.63zm1.509-.32a11.6 11.6 0 0 0 5.616 1.445 11.6 11.6 0 0 0 5.616-1.444 5.625 5.625 0 0 0-11.232 0",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }